import React from "react";

export default function AvatarIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
    >
      <g clip-path="url(#clip0_967_1410)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.99998 0C7.23856 0 4.99998 2.27301 4.99998 5.07692C4.99998 7.88082 7.23856 10.1538 9.99998 10.1538C12.7614 10.1538 15 7.88082 15 5.07692C15 2.27301 12.7614 0 9.99998 0ZM9.99998 11C6.16365 11 3.79185 12.2117 2.40352 13.9471C1.04232 15.6484 0.749196 17.7037 0.745129 19.163C0.740237 20.9164 2.24132 22 3.74339 22H16.2566C17.7586 22 19.2597 20.9164 19.2548 19.163C19.2507 17.7037 18.9576 15.6484 17.5965 13.9471C16.2081 12.2117 13.8363 11 9.99998 11ZM3.74339 20.3077H9.58321H16.2566H3.74339Z"
          fill="#9A9A9A"
        />
      </g>
      <defs>
        <clipPath id="clip0_967_1410">
          <rect width="20" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
